$(document).ready(function () {
  $("#AddToCart").click(function (e) {
    e.preventDefault();
    preloadCart();
    addItem("product-form");
    $('.header-cart').show();
  });

  $('.cart-icon').click(function () {
    preloadCart();
    toggleCart();
    getUpdatedMiniCart();
  });

  $('.mini-cart-remove').click(function () {
    preloadCart();
    var variantId = $(this).data("uid");
    removeItem(variantId)
  })

  $("body > main").click(function (e) {
    if (!$(e.target).hasClass("addToCartBtn")) {
      $('.header-cart').hide();
      $(".cart-icon").removeClass("open")
    }
  })
});

function preloadCart() {
  console.log("here")
  $(".spinner-wrapper").show();
  $(".cart-table").addClass("loading");
}

function toggleCart() {
  $('.header-cart').fadeToggle(500, "swing");
  if ($(".cart-icon").hasClass("open")) {
    $(".cart-icon").removeClass("open")
  } else {
    $(".cart-icon").addClass("open")
  }
}

function getUpdatedMiniCart() {
  $.ajax({
    type: 'GET',
    url: '/pages/minicart',
    dataType: 'html',
    success: updateCartOk,
    error: addToCartFail
  });
}

function updateCartOk(obj, status) {
  console.log("update cart ok!");
  $(".mobile-cart-notice").show()
  $('.header-cart').html(obj)
  $('.mini-cart-remove').click(function () {
    preloadCart();
    var variantId = $(this).data("uid");
    removeItem(variantId)
  })
}

function addToMiniCart(variant_id) {
}


function addItem(form_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + form_id).serialize(),
    success: addToCartOk,
    error: addToCartFail
  });
}


function addToCartOk(product) {
  getUpdatedMiniCart();
}


function addToCartFail(obj, status) {
}


function removeFromCartOk(obj, status) {
  getUpdatedMiniCart();
}


function removeItem(variant_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: 'quantity=0&id=' + variant_id,
    success: removeFromCartOk,
    error: addToCartFail
  });
}


window.checkCart = function (e) {
  var showModal = $("#sidebar-checkout-btn").data("showModal")
  var hasCbd = $("#cbd_check").data("cbd")
  console.log(hasCbd)
  if (showModal == "true") {
    e.preventDefault();
    var itemName = $("#cart-item-name").text()
    $(".cart-modal-item").html(itemName)
    $("#cartModal").modal("show")
  }

  if (hasCbd == true) {
    e.preventDefault();
    console.log("def has cbd")
    var cartItems = $(".main-cart-item")
    if (cartItems.length === 0) {
      cartItems = $(".cart-item")
    }
    var checkStr = ""
    $.map(cartItems, function (item, i) {
      var varId = $(item).data("variantid")
      var quantity = $(item).data("quantity")
      var cbdId = convertCbdVariantId(varId)
      console.log(`hw_id: ${varId}, cbd_id: ${cbdId}`)
      checkStr += `${cbdId}:${quantity},`
    });
    console.log(checkStr)
    window.location = `https://healthwisecbd.myshopify.com/cart/${checkStr}`
  }
}


window.convertCbdVariantId = function (varId) {
  return window.cbd_product_map.filter((e) => {
    return e.hw_variant_id == varId
  }).map((e) => {
    return e.cbd_variant_id
  })[0]
}

window.addSingleItem = function () {
  var prodId = $("#cart-item-uid").text()
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {id: prodId, quantity: 1},
    success: function () {
      window.location.href = "/checkout"
    },
    error: addToCartFail
  });
}


$(document).ready(function () {

  var cartContainer = $(".cart-container").length

  if (cartContainer > 0) {
    var cartItemsCount = parseInt($("#cart-items-input").text());
    var cartTotal = parseFloat($("#cart-total-input").text());

    console.log(cartItemsCount)
    console.log(cartTotal)

    if (cartItemsCount === 1 && cartTotal < 20.00) {
      console.log("TRUE")
      $("#sidebar-checkout-btn").data("showModal", "true")
    } else {
      console.log("FALSE")
      $("#sidebar-checkout-btn").data("showModal", "false")
    }
  }

})


window.cbd_product_map = [
  {"cbd_variant_id": "41938187124981", "hw_variant_id": "4756498627"}, {
    "cbd_variant_id": "41938187157749",
    "hw_variant_id": "4756519747"
  }, {"cbd_variant_id": "41938187190517", "hw_variant_id": "16409375942"}, {
    "cbd_variant_id": "41938187223285",
    "hw_variant_id": "4756519811"
  }, {"cbd_variant_id": "41938187256053", "hw_variant_id": "4756519875"}, {
    "cbd_variant_id": "41938187288821",
    "hw_variant_id": "4756519939"
  }, {"cbd_variant_id": "41964420825333", "hw_variant_id": "31175448166498"}, {
    "cbd_variant_id": "41964420858101",
    "hw_variant_id": "31175448199266"
  }, {"cbd_variant_id": "41964420890869", "hw_variant_id": "31175448232034"}, {
    "cbd_variant_id": "41964420923637",
    "hw_variant_id": "31175448264802"
  }, {"cbd_variant_id": "41964421611765", "hw_variant_id": "31175447576674"}, {
    "cbd_variant_id": "41964421644533",
    "hw_variant_id": "31175447609442"
  }, {"cbd_variant_id": "41964421677301", "hw_variant_id": "31175447642210"}, {
    "cbd_variant_id": "41964421710069",
    "hw_variant_id": "31175447674978"
  }, {"cbd_variant_id": "41964422430965", "hw_variant_id": "41626548934"}, {
    "cbd_variant_id": "41964422463733",
    "hw_variant_id": "41626549062"
  }, {"cbd_variant_id": "41964422496501", "hw_variant_id": "41626549126"}, {
    "cbd_variant_id": "41964422529269",
    "hw_variant_id": "41626549318"
  }, {"cbd_variant_id": "41964423282933", "hw_variant_id": "20047231622"}, {
    "cbd_variant_id": "41964423315701",
    "hw_variant_id": "20047231686"
  }, {"cbd_variant_id": "41964423348469", "hw_variant_id": "20047231750"}, {
    "cbd_variant_id": "41964423381237",
    "hw_variant_id": "31528798086"
  }, {"cbd_variant_id": "41964423479541", "hw_variant_id": "16830936449122"}, {
    "cbd_variant_id": "41964423512309",
    "hw_variant_id": "16830936481890"
  }, {"cbd_variant_id": "41964423545077", "hw_variant_id": "16830936514658"}, {
    "cbd_variant_id": "41964423577845",
    "hw_variant_id": "16830936547426"
  }, {"cbd_variant_id": "41964424134901", "hw_variant_id": "16830908235874"}, {
    "cbd_variant_id": "41964424167669",
    "hw_variant_id": "16830908268642"
  }, {"cbd_variant_id": "41964424200437", "hw_variant_id": "16830908301410"}, {
    "cbd_variant_id": "41964424233205",
    "hw_variant_id": "16830908334178"
  }, {"cbd_variant_id": "41964425838837", "hw_variant_id": "32003198386274"}, {
    "cbd_variant_id": "41964425871605",
    "hw_variant_id": "32003198419042"
  }, {"cbd_variant_id": "41964425904373", "hw_variant_id": "32003198451810"}, {
    "cbd_variant_id": "41964425937141",
    "hw_variant_id": "32003198484578"
  }, {"cbd_variant_id": "41964425969909", "hw_variant_id": "32003195437154"}, {
    "cbd_variant_id": "41964426002677",
    "hw_variant_id": "32003195469922"
  }, {"cbd_variant_id": "41964426035445", "hw_variant_id": "32003195502690"}, {
    "cbd_variant_id": "41964426068213",
    "hw_variant_id": "32003195535458"
  }, {"cbd_variant_id": "41964427378933", "hw_variant_id": "4756557315"}, {
    "cbd_variant_id": "41964427411701",
    "hw_variant_id": "4756557379"
  }, {"cbd_variant_id": "41964427444469", "hw_variant_id": "16409362374"}, {
    "cbd_variant_id": "41964427477237",
    "hw_variant_id": "4756557443"
  }, {"cbd_variant_id": "41964427510005", "hw_variant_id": "4756557507"}, {
    "cbd_variant_id": "41964427542773",
    "hw_variant_id": "4756557571"
  }, {"cbd_variant_id": "41973754462453", "hw_variant_id": "39464184184930"}, {
    "cbd_variant_id": "41973754495221",
    "hw_variant_id": "39464184217698"
  }, {"cbd_variant_id": "41973754527989", "hw_variant_id": "39464184250466"}, {
    "cbd_variant_id": "41973754560757",
    "hw_variant_id": "39464184283234"
  }, {"cbd_variant_id": "41973755642101", "hw_variant_id": "39464175140962"}, {
    "cbd_variant_id": "41973755674869",
    "hw_variant_id": "39464175173730"
  }, {"cbd_variant_id": "41973755707637", "hw_variant_id": "39464175206498"}, {
    "cbd_variant_id": "41973755740405",
    "hw_variant_id": "39464175239266"
  }, {"cbd_variant_id": "42010594115829", "hw_variant_id": "31070926278"}, {
    "cbd_variant_id": "42010594148597",
    "hw_variant_id": "31070926406"
  }, {"cbd_variant_id": "42010594181365", "hw_variant_id": "31070926470"}, {
    "cbd_variant_id": "42010594214133",
    "hw_variant_id": "31070926534"
  }, {"cbd_variant_id": "42010594246901", "hw_variant_id": "31070882950"}, {
    "cbd_variant_id": "42010594279669",
    "hw_variant_id": "31070883014"
  }, {"cbd_variant_id": "42010594312437", "hw_variant_id": "31070883078"}, {
    "cbd_variant_id": "42010594345205",
    "hw_variant_id": "31070883142"
  }, {"cbd_variant_id": "42010595361013", "hw_variant_id": "4758492227"}, {
    "cbd_variant_id": "42010595393781",
    "hw_variant_id": "4759404099"
  }, {"cbd_variant_id": "42010595426549", "hw_variant_id": "4759364739"}, {
    "cbd_variant_id": "42010595459317",
    "hw_variant_id": "4759364803"
  }, {"cbd_variant_id": "42010595492085", "hw_variant_id": "4759364867"}, {
    "cbd_variant_id": "42010595524853",
    "hw_variant_id": "6389299011"
  }, {"cbd_variant_id": "42010595557621", "hw_variant_id": "6389300355"}, {
    "cbd_variant_id": "42010595590389",
    "hw_variant_id": "6389300483"
  }, {"cbd_variant_id": "42010595623157", "hw_variant_id": "15090241094"}, {
    "cbd_variant_id": "42010595655925",
    "hw_variant_id": "15090241926"
  }, {"cbd_variant_id": "42010595852533", "hw_variant_id": "4759354499"}, {
    "cbd_variant_id": "42010595885301",
    "hw_variant_id": "4759354563"
  }, {"cbd_variant_id": "42010595918069", "hw_variant_id": "4759354627"}, {
    "cbd_variant_id": "42010595950837",
    "hw_variant_id": "6389294083"
  }, {"cbd_variant_id": "42010595983605", "hw_variant_id": "6389294147"}, {
    "cbd_variant_id": "42010596016373",
    "hw_variant_id": "6389295491"
  }, {"cbd_variant_id": "42010596049141", "hw_variant_id": "15090238278"}, {
    "cbd_variant_id": "42010596081909",
    "hw_variant_id": "15090239558"
  }, {"cbd_variant_id": "42010596114677", "hw_variant_id": "4757096195"}, {
    "cbd_variant_id": "42010596147445",
    "hw_variant_id": "7189086787"
  }, {"cbd_variant_id": "42010596180213", "hw_variant_id": "4757096259"}, {
    "cbd_variant_id": "42010596212981",
    "hw_variant_id": "7189094275"
  }, {"cbd_variant_id": "42010596245749", "hw_variant_id": "4757096323"}, {
    "cbd_variant_id": "42010596278517",
    "hw_variant_id": "7189095619"
  }, {"cbd_variant_id": "42010596311285", "hw_variant_id": "15092030470"}, {
    "cbd_variant_id": "42010596344053",
    "hw_variant_id": "15092028230"
  }, {"cbd_variant_id": "42010596376821", "hw_variant_id": "4757298371"}, {
    "cbd_variant_id": "42010596409589",
    "hw_variant_id": "4757298435"
  }, {"cbd_variant_id": "42010596442357", "hw_variant_id": "4757298499"}, {
    "cbd_variant_id": "42010596475125",
    "hw_variant_id": "7189066755"
  }, {"cbd_variant_id": "42010596507893", "hw_variant_id": "7189072707"}, {
    "cbd_variant_id": "42010596540661",
    "hw_variant_id": "7189076803"
  }, {"cbd_variant_id": "42010596573429", "hw_variant_id": "15092018822"}, {
    "cbd_variant_id": "42010596606197",
    "hw_variant_id": "15092022214"
  }, {"cbd_variant_id": "42010596638965", "hw_variant_id": "4757333891"}, {
    "cbd_variant_id": "42010596671733",
    "hw_variant_id": "4757358595"
  }, {"cbd_variant_id": "42010596704501", "hw_variant_id": "33368980294"}, {
    "cbd_variant_id": "42010596737269",
    "hw_variant_id": "33369060806"
  }, {"cbd_variant_id": "42010596802805", "hw_variant_id": "4759278595"}, {
    "cbd_variant_id": "42010596835573",
    "hw_variant_id": "4759278659"
  }, {"cbd_variant_id": "42010596868341", "hw_variant_id": "4759278723"}, {
    "cbd_variant_id": "42010596901109",
    "hw_variant_id": "6389290243"
  }, {"cbd_variant_id": "42010596933877", "hw_variant_id": "6389290371"}, {
    "cbd_variant_id": "42010596966645",
    "hw_variant_id": "6389291459"
  }, {"cbd_variant_id": "42010596999413", "hw_variant_id": "15090235398"}, {
    "cbd_variant_id": "42010597032181",
    "hw_variant_id": "17287880262"
  }, {"cbd_variant_id": "42010597064949", "hw_variant_id": "4759332803"}, {
    "cbd_variant_id": "42010597097717",
    "hw_variant_id": "4759332867"
  }, {"cbd_variant_id": "42010597130485", "hw_variant_id": "4759332995"}, {
    "cbd_variant_id": "42010597163253",
    "hw_variant_id": "6389287619"
  }, {"cbd_variant_id": "42010597196021", "hw_variant_id": "6389287875"}, {
    "cbd_variant_id": "42010597228789",
    "hw_variant_id": "6389289283"
  }, {"cbd_variant_id": "42010597261557", "hw_variant_id": "15090233094"}, {
    "cbd_variant_id": "42010597294325",
    "hw_variant_id": "15090233862"
  }, {"cbd_variant_id": "42010597327093", "hw_variant_id": "4759153987"}, {
    "cbd_variant_id": "42010597359861",
    "hw_variant_id": "6389123715"
  }, {"cbd_variant_id": "42010597392629", "hw_variant_id": "4759154179"}, {
    "cbd_variant_id": "42010597425397",
    "hw_variant_id": "6389281411"
  }, {"cbd_variant_id": "42010597458165", "hw_variant_id": "4759154051"}, {
    "cbd_variant_id": "42010597490933",
    "hw_variant_id": "6389280259"
  }, {"cbd_variant_id": "42010597523701", "hw_variant_id": "4759154115"}, {
    "cbd_variant_id": "42010597556469",
    "hw_variant_id": "6389280387"
  }, {"cbd_variant_id": "42010597589237", "hw_variant_id": "15090230790"}, {
    "cbd_variant_id": "42010597622005",
    "hw_variant_id": "15090229446"
  }, {"cbd_variant_id": "42010597687541", "hw_variant_id": "4759142659"}, {
    "cbd_variant_id": "42010597720309",
    "hw_variant_id": "4759142723"
  }, {"cbd_variant_id": "42010597753077", "hw_variant_id": "4759142787"}, {
    "cbd_variant_id": "42010597785845",
    "hw_variant_id": "4759142851"
  }, {"cbd_variant_id": "42010597818613", "hw_variant_id": "6389255939"}, {
    "cbd_variant_id": "42010597851381",
    "hw_variant_id": "6389256131"
  }, {"cbd_variant_id": "42010597884149", "hw_variant_id": "6389256323"}, {
    "cbd_variant_id": "42010597916917",
    "hw_variant_id": "6389258499"
  }, {"cbd_variant_id": "42010597949685", "hw_variant_id": "15090223622"}, {
    "cbd_variant_id": "42010597982453",
    "hw_variant_id": "15090226054"
  }, {"cbd_variant_id": "42010598047989", "hw_variant_id": "4759051011"}, {
    "cbd_variant_id": "42010598080757",
    "hw_variant_id": "4759051075"
  }, {"cbd_variant_id": "42010598113525", "hw_variant_id": "4759051203"}, {
    "cbd_variant_id": "42010598146293",
    "hw_variant_id": "4759096387"
  }, {"cbd_variant_id": "42010598179061", "hw_variant_id": "6389245635"}, {
    "cbd_variant_id": "42010598211829",
    "hw_variant_id": "6389246083"
  }, {"cbd_variant_id": "42010598244597", "hw_variant_id": "6389251203"}, {
    "cbd_variant_id": "42010598277365",
    "hw_variant_id": "6389252547"
  }, {"cbd_variant_id": "42010598310133", "hw_variant_id": "15090215814"}, {
    "cbd_variant_id": "42010598342901",
    "hw_variant_id": "15090218246"
  }, {"cbd_variant_id": "42010599850229", "hw_variant_id": "4759112195"}, {
    "cbd_variant_id": "42010599882997",
    "hw_variant_id": "4759112259"
  }, {"cbd_variant_id": "42010599915765", "hw_variant_id": "4759112387"}, {
    "cbd_variant_id": "42010599948533",
    "hw_variant_id": "4759112451"
  }, {"cbd_variant_id": "42010599981301", "hw_variant_id": "6389234371"}, {
    "cbd_variant_id": "42010600014069",
    "hw_variant_id": "6389235459"
  }, {"cbd_variant_id": "42010600046837", "hw_variant_id": "6389235779"}, {
    "cbd_variant_id": "42010600079605",
    "hw_variant_id": "6389236163"
  }, {"cbd_variant_id": "42010600112373", "hw_variant_id": "15090205830"}, {
    "cbd_variant_id": "42010600145141",
    "hw_variant_id": "15090209286"
  }, {"cbd_variant_id": "42010601750773", "hw_variant_id": "4759466883"}, {
    "cbd_variant_id": "42010601816309",
    "hw_variant_id": "4756786947"
  }, {"cbd_variant_id": "42010601849077", "hw_variant_id": "4756787011"}, {
    "cbd_variant_id": "42010601881845",
    "hw_variant_id": "4756787075"
  }, {"cbd_variant_id": "42010601914613", "hw_variant_id": "7189117379"}, {
    "cbd_variant_id": "42010601947381",
    "hw_variant_id": "7189125635"
  }, {"cbd_variant_id": "42010601980149", "hw_variant_id": "7189126723"}, {
    "cbd_variant_id": "42010602012917",
    "hw_variant_id": "15091822854"
  }, {"cbd_variant_id": "42010602045685", "hw_variant_id": "15091826566"}, {
    "cbd_variant_id": "42010602111221",
    "hw_variant_id": "4756917187"
  }, {"cbd_variant_id": "42010602143989", "hw_variant_id": "4756917251"}, {
    "cbd_variant_id": "42010602176757",
    "hw_variant_id": "4756917315"
  }, {"cbd_variant_id": "42010602209525", "hw_variant_id": "7189008515"}, {
    "cbd_variant_id": "42010602242293",
    "hw_variant_id": "7189024259"
  }, {"cbd_variant_id": "42010602275061", "hw_variant_id": "7189031043"}, {
    "cbd_variant_id": "42010602307829",
    "hw_variant_id": "15091813446"
  }, {"cbd_variant_id": "42010602340597", "hw_variant_id": "15091816262"}, {
    "cbd_variant_id": "42010602373365",
    "hw_variant_id": "4757055747"
  }, {"cbd_variant_id": "42010602406133", "hw_variant_id": "4756873475"}, {
    "cbd_variant_id": "42010602832117",
    "hw_variant_id": "33371811590"
  }, {"cbd_variant_id": "42010602864885", "hw_variant_id": "33371807430"}, {
    "cbd_variant_id": "42010602897653",
    "hw_variant_id": "4758638659"
  }, {"cbd_variant_id": "42010602930421", "hw_variant_id": "4758638723"}, {
    "cbd_variant_id": "42010602963189",
    "hw_variant_id": "4758638787"
  }, {"cbd_variant_id": "42010602995957", "hw_variant_id": "6389225475"}, {
    "cbd_variant_id": "42010603028725",
    "hw_variant_id": "6389226243"
  }, {"cbd_variant_id": "42010603061493", "hw_variant_id": "6389227267"}, {
    "cbd_variant_id": "42010603094261",
    "hw_variant_id": "15090191366"
  }, {"cbd_variant_id": "42010603127029", "hw_variant_id": "15090200134"}, {
    "cbd_variant_id": "42010603159797",
    "hw_variant_id": "4758783619"
  }, {"cbd_variant_id": "42010603192565", "hw_variant_id": "4758783683"}, {
    "cbd_variant_id": "42010603225333",
    "hw_variant_id": "4758783747"
  }, {"cbd_variant_id": "42010603258101", "hw_variant_id": "6389220163"}, {
    "cbd_variant_id": "42010603290869",
    "hw_variant_id": "6389221571"
  }, {"cbd_variant_id": "42010603323637", "hw_variant_id": "6389223299"}, {
    "cbd_variant_id": "42010603356405",
    "hw_variant_id": "15090184774"
  }, {"cbd_variant_id": "42010603389173", "hw_variant_id": "15090187270"}, {
    "cbd_variant_id": "42010603454709",
    "hw_variant_id": "20401441222"
  }, {"cbd_variant_id": "42010603487477", "hw_variant_id": "20401441414"}, {
    "cbd_variant_id": "42010603520245",
    "hw_variant_id": "20401441734"
  }, {"cbd_variant_id": "42010603553013", "hw_variant_id": "20401441990"}, {
    "cbd_variant_id": "42010603585781",
    "hw_variant_id": "20401442182"
  }, {"cbd_variant_id": "42010603618549", "hw_variant_id": "20401442310"}, {
    "cbd_variant_id": "42010603651317",
    "hw_variant_id": "20401442438"
  }, {"cbd_variant_id": "42010603684085", "hw_variant_id": "20401442566"}, {
    "cbd_variant_id": "42010603716853",
    "hw_variant_id": "4758658371"
  }, {"cbd_variant_id": "42010603749621", "hw_variant_id": "4758658435"}, {
    "cbd_variant_id": "42010603782389",
    "hw_variant_id": "4758658499"
  }, {"cbd_variant_id": "42010603815157", "hw_variant_id": "6389182147"}, {
    "cbd_variant_id": "42010603847925",
    "hw_variant_id": "6389185283"
  }, {"cbd_variant_id": "42010603880693", "hw_variant_id": "6389196547"}, {
    "cbd_variant_id": "42010603913461",
    "hw_variant_id": "15090172678"
  }, {"cbd_variant_id": "42010603946229", "hw_variant_id": "15090175686"}, {
    "cbd_variant_id": "42010603978997",
    "hw_variant_id": "4759644355"
  }, {"cbd_variant_id": "42010604011765", "hw_variant_id": "6470276035"}, {
    "cbd_variant_id": "42010604044533",
    "hw_variant_id": "6470276099"
  }, {"cbd_variant_id": "42010604077301", "hw_variant_id": "4759614723"}, {
    "cbd_variant_id": "42010604110069",
    "hw_variant_id": "4756009539"
  }, {"cbd_variant_id": "42010604142837", "hw_variant_id": "4756009603"}, {
    "cbd_variant_id": "42010604175605",
    "hw_variant_id": "4756009475"
  }, {"cbd_variant_id": "42010604208373", "hw_variant_id": "7190782339"}, {
    "cbd_variant_id": "42010604241141",
    "hw_variant_id": "7190650499"
  }, {"cbd_variant_id": "42010604273909", "hw_variant_id": "7190738883"}, {
    "cbd_variant_id": "42010604306677",
    "hw_variant_id": "7190722307"
  }, {"cbd_variant_id": "42010604339445", "hw_variant_id": "7190722371"}, {
    "cbd_variant_id": "42010604372213",
    "hw_variant_id": "7190722435"
  }, {"cbd_variant_id": "42010604404981", "hw_variant_id": "7190722499"}, {
    "cbd_variant_id": "42010604437749",
    "hw_variant_id": "7190722563"
  }, {"cbd_variant_id": "42010604470517", "hw_variant_id": "7190722627"}, {
    "cbd_variant_id": "42010604503285",
    "hw_variant_id": "7190722691"
  }, {"cbd_variant_id": "42010604536053", "hw_variant_id": "7190722755"}, {
    "cbd_variant_id": "42010604568821",
    "hw_variant_id": "7190722819"
  }, {"cbd_variant_id": "42010604601589", "hw_variant_id": "7190722883"}, {
    "cbd_variant_id": "42010604634357",
    "hw_variant_id": "7190722947"
  }, {"cbd_variant_id": "42010604667125", "hw_variant_id": "7190723011"}, {
    "cbd_variant_id": "42010604699893",
    "hw_variant_id": "7190723075"
  }, {"cbd_variant_id": "42010604732661", "hw_variant_id": "7190723139"}, {
    "cbd_variant_id": "42010604765429",
    "hw_variant_id": "7190723203"
  }, {"cbd_variant_id": "42010604798197", "hw_variant_id": "7190723267"}, {
    "cbd_variant_id": "42010604830965",
    "hw_variant_id": "7190723331"
  }, {"cbd_variant_id": "42010604863733", "hw_variant_id": "7190723395"}, {
    "cbd_variant_id": "42010604896501",
    "hw_variant_id": "7190723459"
  }, {"cbd_variant_id": "42010604929269", "hw_variant_id": "7190723523"}, {
    "cbd_variant_id": "42010604962037",
    "hw_variant_id": "7190723587"
  }, {"cbd_variant_id": "42010604994805", "hw_variant_id": "7190723651"}, {
    "cbd_variant_id": "42010605027573",
    "hw_variant_id": "7190723715"
  }, {"cbd_variant_id": "42010605060341", "hw_variant_id": "7190723779"}, {
    "cbd_variant_id": "42010605093109",
    "hw_variant_id": "7190723843"
  }, {"cbd_variant_id": "42010605125877", "hw_variant_id": "7190723907"}, {
    "cbd_variant_id": "42010605158645",
    "hw_variant_id": "7190724035"
  }, {"cbd_variant_id": "42010605191413", "hw_variant_id": "7190724099"}, {
    "cbd_variant_id": "42010605224181",
    "hw_variant_id": "7190724163"
  }, {"cbd_variant_id": "42010605256949", "hw_variant_id": "7190724227"}, {
    "cbd_variant_id": "42010605289717",
    "hw_variant_id": "8695225923"
  }, {"cbd_variant_id": "42010605322485", "hw_variant_id": "8695225987"}, {
    "cbd_variant_id": "42010605355253",
    "hw_variant_id": "8695226051"
  }, {"cbd_variant_id": "42010605388021", "hw_variant_id": "15090127110"}, {
    "cbd_variant_id": "42010605453557",
    "hw_variant_id": "9757002371"
  }, {"cbd_variant_id": "42010605486325", "hw_variant_id": "9757002435"}, {
    "cbd_variant_id": "42010605519093",
    "hw_variant_id": "9757002307"
  }, {"cbd_variant_id": "42010605551861", "hw_variant_id": "15090122694"}, {
    "cbd_variant_id": "42010605584629",
    "hw_variant_id": "12140062278"
  }, {"cbd_variant_id": "42010605617397", "hw_variant_id": "12140084550"}, {
    "cbd_variant_id": "42010605682933",
    "hw_variant_id": "20401004294"
  }, {"cbd_variant_id": "42010605748469", "hw_variant_id": "20401106054"}, {
    "cbd_variant_id": "42010605781237",
    "hw_variant_id": "33371884934"
  }, {"cbd_variant_id": "42010605846773", "hw_variant_id": "33371904774"}, {
    "cbd_variant_id": "42010605879541",
    "hw_variant_id": "4759534659"
  }, {"cbd_variant_id": "42010605912309", "hw_variant_id": "6469893827"}, {
    "cbd_variant_id": "42010605945077",
    "hw_variant_id": "6469893955"
  }, {"cbd_variant_id": "42010605977845", "hw_variant_id": "6469894019"}, {
    "cbd_variant_id": "42010606010613",
    "hw_variant_id": "6469894147"
  }, {"cbd_variant_id": "42010606043381", "hw_variant_id": "4759219203"}, {
    "cbd_variant_id": "42010606108917",
    "hw_variant_id": "4759245379"
  }, {"cbd_variant_id": "42010606141685", "hw_variant_id": "33371804550"}, {
    "cbd_variant_id": "42010606174453",
    "hw_variant_id": "33371802246"
  }, {"cbd_variant_id": "42010606207221", "hw_variant_id": "32898804230"}, {
    "cbd_variant_id": "42010606239989",
    "hw_variant_id": "32898849350"
  }, {"cbd_variant_id": "42010606272757", "hw_variant_id": "4759565123"}, {
    "cbd_variant_id": "42010606305525",
    "hw_variant_id": "12140124038"
  }, {"cbd_variant_id": "42010606338293", "hw_variant_id": "33371797190"}, {
    "cbd_variant_id": "42010606371061",
    "hw_variant_id": "31938359263330"
  }, {"cbd_variant_id": "42010606403829", "hw_variant_id": "4759188035"}, {
    "cbd_variant_id": "42010606436597",
    "hw_variant_id": "4759178691"
  }, {"cbd_variant_id": "42010606469365", "hw_variant_id": "33371789190"}, {
    "cbd_variant_id": "42010606502133",
    "hw_variant_id": "33371783942"
  }, {"cbd_variant_id": "42010606534901", "hw_variant_id": "31927704420450"}, {
    "cbd_variant_id": "42010606567669",
    "hw_variant_id": "31927704453218"
  }, {"cbd_variant_id": "42010606600437", "hw_variant_id": "31927704485986"}, {
    "cbd_variant_id": "42010606633205",
    "hw_variant_id": "31927704518754"
  }, {"cbd_variant_id": "42010606665973", "hw_variant_id": "4758842691"}, {
    "cbd_variant_id": "42010606698741",
    "hw_variant_id": "4758970371"
  }, {"cbd_variant_id": "42010606731509", "hw_variant_id": "33371778886"}, {
    "cbd_variant_id": "42010606764277",
    "hw_variant_id": "33371770054"
  }, {"cbd_variant_id": "42010606797045", "hw_variant_id": "9756910211"}, {
    "cbd_variant_id": "42010606829813",
    "hw_variant_id": "9756910403"
  }, {"cbd_variant_id": "42010606862581", "hw_variant_id": "9756910467"}, {
    "cbd_variant_id": "42010606895349",
    "hw_variant_id": "15090111494"
  }, {"cbd_variant_id": "42010606928117", "hw_variant_id": "9757060867"}, {
    "cbd_variant_id": "42010606960885",
    "hw_variant_id": "9757060931"
  }, {"cbd_variant_id": "42010606993653", "hw_variant_id": "9757060803"}, {
    "cbd_variant_id": "42010607026421",
    "hw_variant_id": "15090045766"
  }, {"cbd_variant_id": "42010607059189", "hw_variant_id": "31070782278"}, {
    "cbd_variant_id": "42010607091957",
    "hw_variant_id": "31070782406"
  }, {"cbd_variant_id": "42010607124725", "hw_variant_id": "31070782470"}, {
    "cbd_variant_id": "42010607157493",
    "hw_variant_id": "31070782534"
  }, {"cbd_variant_id": "42010607190261", "hw_variant_id": "31070409734"}, {
    "cbd_variant_id": "42010607223029",
    "hw_variant_id": "31070409798"
  }, {"cbd_variant_id": "42010607255797", "hw_variant_id": "31070409862"}, {
    "cbd_variant_id": "42010607288565",
    "hw_variant_id": "31070409926"
  }, {"cbd_variant_id": "42010607321333", "hw_variant_id": "4758809539"}, {
    "cbd_variant_id": "42010607354101",
    "hw_variant_id": "4758940035"
  }, {"cbd_variant_id": "42010607386869", "hw_variant_id": "33371766150"}, {
    "cbd_variant_id": "42010607419637",
    "hw_variant_id": "33371752262"
  }, {"cbd_variant_id": "42010607485173", "hw_variant_id": "4758915587"},
  {
    "cbd_variant_id": "42010607583477",
    "hw_variant_id": "33371700678"
  },
  {
    "cbd_variant_id": "42181321195765",
    "hw_variant_id": "39518477058146"
  },
  {
    "cbd_variant_id": "42181321392373",
    "hw_variant_id": "39518491574370"
  }
  ]
